import { UserService } from './../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit  } from '@angular/core';
// declare var $:JQueryStatic;
import $ from 'jquery';
@Component({
  selector: 'app-functions',
  templateUrl: './functions.component.html',
  styleUrls: ['./functions.component.css']
})
export class FunctionsComponent implements OnInit {

  menuList:any;
  pageList:any;
  @ViewChild('panel', { read: ElementRef }) public panel;
  constructor(private service: UserService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Functions')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }
  public scrollDivLeft():void{    
    this.panel.nativeElement.scrollLeft -= 100;
  }
  
  public scrollDivRight():void {
    this.panel.nativeElement.scrollLeft += 100;
  }
  NavigateUrl(URL: any) {
    debugger;
    if (URL) {
      this.router.navigate([URL]);
    }
  }

  // 

  
}



// WEBPACK FOOTER //
// ./src/app/pages/functions/functions.component.ts